import dynamic from 'next/dynamic';

import styles from '@styles/dropAuction/dropAuction.module.scss';
const DropLandingBrand = dynamic(() =>
	import('@components/dropAuction/landing/dropLandingBrand'),
);
const HowItWork = dynamic(() =>
	import('@components/dropAuction/common/howItWork'),
);
const WatchAuction = dynamic(() =>
	import('@components/dropAuction/common/watchAuction'),
);

const LiveAuction = dynamic(() =>
	import('@components/dropAuction/liveAuction/liveAuction'),
);

const DropAuctionLanding = () => {
	return (
		<div className={styles.dropLanding}>
			<div className={styles.dropLanding}>
				<div className={`${styles.containerTop} container`}>
					<DropLandingBrand />
					<HowItWork />
				</div>
				<WatchAuction />
				<LiveAuction heading={'Upcoming Auctions'} />
			</div>
		</div>
	);
};

export default DropAuctionLanding;
